import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { mockDomains } from '../data/mockData';
import '../styles/DomainsSlider.css';

const DomainsSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev + 1) % mockDomains.length);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev - 1 + mockDomains.length) % mockDomains.length);
    setTimeout(() => setIsAnimating(false), 500);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % mockDomains.length);
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section id="domains" className="domains-slider">
      <div className="slider-background">
        <div className="slider-overlay"></div>
        <div className="slider-content">
          <h2 className="section-title">OUR DOMAINS</h2>
          <div className="slide-wrapper">
            <div className={`slide-content ${isAnimating ? 'slide-fade' : ''}`}>
              <h3 className="slide-title">{mockDomains[currentSlide].title}</h3>
              <p className="slide-description">{mockDomains[currentSlide].description}</p>
            </div>
          </div>
          
          <div className="slider-controls">
            <button 
              className="slider-btn slider-btn-prev" 
              onClick={prevSlide}
              aria-label="Previous slide"
            >
              <ChevronLeft size={24} />
              <span>PREV</span>
            </button>
            
            <div className="slider-pagination">
              <span className="current-slide">
                {String(currentSlide + 1).padStart(2, '0')}
              </span>
              <div className="pagination-line"></div>
              <span className="total-slides">
                {String(mockDomains.length).padStart(2, '0')}
              </span>
            </div>
            
            <button 
              className="slider-btn slider-btn-next" 
              onClick={nextSlide}
              aria-label="Next slide"
            >
              <span>NEXT</span>
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DomainsSlider;